import { get as getLocal, set as setLocal } from '@/lib/local-storage';
import { ThemeOptions } from '@mui/material';
import { createContext } from 'react';
import { F5Theme } from '@/theme/f5';
import { SurePathTheme } from '@/theme/surepath';
export type ThemeName = 'surepath' | 'f5';

export const THEMES: Record<ThemeName, ThemeOptions> = {
  surepath: SurePathTheme,
  f5: F5Theme,
};

export const DEFAULT_THEME: ThemeName = 'f5';

const STORAGE_KEY = 'theme-name';

export const setThemeName = (name: ThemeName): void => {
  setLocal(STORAGE_KEY, name);
};

export const getThemeName = (): ThemeName | null => {
  const stored = getLocal(STORAGE_KEY) as ThemeName | null;
  return stored && stored in THEMES ? stored : null;
};

export interface AppThemeState {
  themeName: ThemeName;
  setThemeName: (name: ThemeName) => void;
}

export const AppThemeContext = createContext<AppThemeState>({
  themeName: DEFAULT_THEME,
  setThemeName: () => null,
});
